import { render, staticRenderFns } from "./PreviewVideo.vue?vue&type=template&id=86c0391c&scoped=true&"
import script from "./PreviewVideo.vue?vue&type=script&lang=js&"
export * from "./PreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVideo.vue?vue&type=style&index=0&id=86c0391c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c0391c",
  null
  
)

export default component.exports